import { render, staticRenderFns } from "./DeleteAccountReviewActionsOrganizationsOwnerModal.vue?vue&type=template&id=49c96d86&scoped=true&lang=pug"
import script from "./DeleteAccountReviewActionsOrganizationsOwnerModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountReviewActionsOrganizationsOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountReviewActionsOrganizationsOwnerModal.vue?vue&type=style&index=0&id=49c96d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c96d86",
  null
  
)

export default component.exports